import { gql } from '@apollo/client'

export const GET_CAMPAIGN_LOCATION_FILE = gql`
  query campaignLocationsFile($campaignId: ID!) {
    campaignLocationsFile(campaignId: $campaignId) {
      url
    }
  }
`
